import type { MedNecCaseView } from '../types/medNecTypes';

export interface MedNecCaseSliceState {
  currentCase: MedNecCaseView | null;
  serverCase: MedNecCaseView | null;
  draftCase: MedNecCaseView | null;
  selectedCaseId: string | null;
  isEdited: boolean;
  editedFields: string[];
  filters: {
    status: string | null;
    facility: string | null;
  };
}

export const initialState: MedNecCaseSliceState = {
  currentCase: null,
  serverCase: null,
  draftCase: null,
  selectedCaseId: null,
  isEdited: false,
  editedFields: [],
  filters: {
    status: null,
    facility: null,
  },
};
